import { render, staticRenderFns } from "./ModalAIInsufficientCredit.vue?vue&type=template&id=735f38e2&scoped=true&"
import script from "./ModalAIInsufficientCredit.vue?vue&type=script&lang=js&"
export * from "./ModalAIInsufficientCredit.vue?vue&type=script&lang=js&"
import style0 from "./ModalAIInsufficientCredit.vue?vue&type=style&index=0&id=735f38e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735f38e2",
  null
  
)

export default component.exports